<template>
	<div>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-资源工具池</span>-{{toolsDetail.title}}</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			<div class="body-left">
				<div class="left-head">
					发布人
				</div>
				<div class="left-body">
					<div class="body-item">
						<div class="item-title" v-if="toolsDetail.user_info">
							{{toolsDetail.user_info.nickname }}
						</div>
						<div class="item-content">
							联系方式:{{toolsDetail.user_info.mobile || toolsDetail.user_info.email }}
						</div>
					</div>
					<div class="body-item">
						<div class="item-title">
							时间线
						</div>
						<div class="item-content">
							创建时间:{{timeConversion(toolsDetail.createtime)}}
						</div>
						<div class="item-content">
							修改时间:{{timeConversion(toolsDetail.updatetime)}}
						</div>
					</div>


				</div>
			</div>
			<div class="body-main">
				<div class="main-header">
					<div class="head-left">
						<img :src='getImgSrc(toolsDetail.image)' style="width: 238px;height: 238px;" alt="">
					</div>
					<div class="head-right">
						<div class="title">
							{{toolsDetail.title}}
						</div>
						<div class="content">
							<div class="content-l">

								<div class="content-item"><span
										class="biaoti">学科</span>：<span>{{toolsDetail.subjectcate_name}}</span></div>
								<div class="content-item"> <span
										class="biaoti">阶段</span>：<span>{{toolsDetail.stage_name}}</span></div>
								<div class="content-item"> <span class="biaoti">状态</span>：
									<span style="color: #0052D9;" v-if="toolsDetail.status == 2">应助中</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 1">待审核</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 3">已投条</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 4">执行中</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 5">已归档</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 6">已存挡</span>
								</div>

								<!-- //状态:1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->

							</div>
							<div class="content-r">
								<div class="content-item"><span
										class="biaoti">行业</span>：<span>{{toolsDetail.industry_name}}</span></div>
								<div class="content-item"> <span class="biaoti">关 键
										词</span>：<span>{{toolsDetail.tags}}</span></div>

							</div>
						</div>
						<div class="bottom">
							<span style="color: #0052D9;"><i class="el-icon-view"
									style="font-size: 20px;"></i>{{toolsDetail.hits}}</span>

							<span style="margin-left:30px;cursor: pointer;"
								:style="toolsDetail.praise == 1?'color: #0052D9;':''"><i class="iconfont icon-zan"
									v-throttle="[LikeHandler,2000,`click`]"
									style="font-size:20px;"></i>{{toolsDetail.praiset_num}}</span>

							<span style="margin-left: 30px;cursor: pointer;"
								:style="toolsDetail.tread==1?'color: #0052D9;':''"><i class="iconfont icon-lacai"
									v-throttle="[ShitHandler,2000,`click`]"
									style="font-size: 18px;">{{toolsDetail.tread_num}}</i></span>

							<span style="margin-left: 30px;cursor: pointer;"
								:style="toolsDetail.collect == 1?'color: #0052D9;':''"><i class="iconfont icon-xiai"
									v-throttle="[collectasd,2000,`click`]"
									style="font-size: 18px;"></i>{{toolsDetail.collect_num}}</span>

							<div style="position: relative;" class="shareIconWrap">
								<span style="margin-left: 30px;cursor: pointer;"
									:style="toolsDetail.share == 1?'color: #0052D9;':''"><i
										class="iconfont icon-fenxiang"
										style="font-size: 20px;"></i>{{toolsDetail.share_num}}</span>
								<div class="shareIcon"
									style="position: absolute;background: #fff;width: 200px;display: flex;align-items: center;justify-content: center;left:0px;height: 50px;top:-50px">
									<goShare :zytitle="toolsDetail.title" @share='reoserceShare'></goShare>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="main-body" style="min-height: 500px;">
					<div class="title">
						<div :class="'active'">项目状态</div>

					</div>
					<div v-if="yzList.lists.length">
						<div class="body-item-title">
							<span>1、选中成交乙方</span>
							<div @click="toDeal">选为最佳答案，发放积分</div>
						</div>
						<div class="item-detail">
							<div class="table">
								<el-radio-group v-model="result" style="width: 100%;" :disabled='yzList.check_id!=0'>
									<div class="table-line" v-for="(item,index) in yzList.lists"
										:style="index%2==0?'background: #FAFAFA;':''">
										<div class="line-check">
											<el-radio type="checkbox" :label="item.id">{{ '' }}</el-radio>
										</div>
										<div class="line-id">
											{{index+1}}
										</div>
										<div class="fangan" @click="showDetail(item)" style="cursor: pointer;">
											方案详情
										</div>
										<div class="nickName">
											{{item.nickname}}
										</div>

										<div class="status">
											<span v-if="item.check_status ==1" style="color: #0052D9;">已采纳方案</span>
											<span v-if="item.check_status ==0" style="color: black;">未采纳方案</span>
										</div>
									</div>
								</el-radio-group>
							</div>


						</div>
					</div>
					<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
						<el-empty :image-size="200"></el-empty>
					</div>
					<div v-if="bindInfo">
						<div>
							<div class="body-item">
								<div class="body-item-title">
									<span>双方互评</span>
								</div>
							</div>
							<div style="padding: 10px 15px">
								<div class="table">
									<div class="table-line" style="display: flex;">

										<div class="jindu"
											style="flex: 1;overflow-x: auto;white-space: nowrap;text-overflow: ellipsis;">
											甲方评价：{{bindInfo.bid_acquire_remark ? bindInfo.bid_acquire_remark : '暂未评价'}}
										</div>
										<div class="starScore" v-if="bindInfo.bid_acquire_score">
											<el-rate allow-half v-model="bindInfo.bid_acquire_score * 1"
												disabled></el-rate>
										</div>
									</div>
									<div class="table-line" style="display: flex;">

										<div class="jindu"
											style="flex: 1;overflow-x: auto;white-space: nowrap;text-overflow: ellipsis;">
											乙方评价：{{bindInfo.owner_acquire_remark ? bindInfo.owner_acquire_remark : '暂未评价'}}
										</div>
										<div class="starScore" v-if="bindInfo.owner_acquire_score">
											<el-rate allow-half v-model="bindInfo.owner_acquire_score * 1"
												disabled></el-rate>
										</div>
									</div>
								</div>
							</div>
							<div class="item-detail">
								<p style="display: flex;">评分： <el-rate allow-half v-model="starScore"></el-rate></p>
								<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="PJarea">
								</el-input>
								<div style="display: flex;justify-content: flex-end;">
									<div class="pinglBtn" @click="projectAcommentB">发表评论</div>
								</div>
							</div>
						</div>
					</div>
					<el-dialog :title="yzInfo.nickname" center :visible.sync="dialogVisible1" width="800px">
						<div style=" margin-bottom: 30px;">
							<h3>缩略图：</h3>
							<div style="padding:20px">
								<img :src="getImgSrc(yzInfo.image)" style="max-width: 100%;" alt="">
							</div>
						</div>
						<h3>完整版：</h3>
						<div style="width: 100%;padding: 20px;padding-left: 50px;" v-html="yzInfo.content_info">

						</div>

						<!-- <span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible1 = false">取 消</el-button>
							<el-button type="primary" >确 定</el-button>
						</span> -->
					</el-dialog>
					<!-- 	<div class="body-mid-footer">
					    加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div> -->

				</div>

			</div>
			<div class="body-right">
				<div class="body-right">
					<div style="background: #0052D9;" @click="$router.push('/zyTools/createTools')">
						<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
							style="width:80px">发布</span>
					</div>
					<div style="background: #3399FF;position: relative;" class="shareBox">
						<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">分享</span>
						<div class="share"
							style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;left: 200px;height: 50px;">
							<goShare @share='reoserceShare' :zytitle="toolsDetail.title"></goShare>
						</div>
					</div>

					<div style="background: #18BC9C;" v-throttle="[LikeHandler,2000,`click`]">
						<img src='../../assets/images/dianzan.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">点赞</span>
					</div>


				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import goShare from '../../components/share.vue'
	export default {
		components: {
			goShare
		},
		data() {
			return {
				title: '',
				whereForm: "",
				shoucang: false,
				toolsDetail: [],
				result: '',
				table: [{
						value: '1',
						link: '方案页面链接',
						nickName: '乙方用户名',
						score: 4.3,
						type: '1'
					},
					{
						value: '2',
						link: '方案页面链接',
						nickName: '乙方用户名',
						score: 4.3,
						type: '2'
					},
					{
						value: '3',
						link: '方案页面链接',
						nickName: '乙方用户名',
						score: 4.3,
						type: '1'
					}
				],
				yzList: [],
				dialogVisible1: false,
				yzInfo: {},
				bindInfo: '',
				PJarea: '',
				starScore: ''
			}
		},
		created() {
			this.getToolDetail()
			this.getYzList()
		},

		methods: {
			async projectAcommentB() {
				console.log('1231231231231212adeasdad');
				const comment = await this.$api.toolsAcommentB({
					bid_acquire_remark: this.PJarea,
					bid_acquire_score: this.starScore,
					instrumenthelp_id: this.toolsDetail.id
				})
				if (comment.code == 1) {
					this.$message({
						message: comment.msg,
						type: 'success'
					})
					this.getToolsBindInfo()
					this.starScore = ''
					this.PJarea = ''
				} else {
					this.$message({
						message: comment.msg,
						type: 'error'
					})
				}
			},
			async getToolsBindInfo() {
				const info = await this.$api.getToolsBindInfo({
					instrumenthelp_id: this.toolsDetail.id
				})
				this.bindInfo = info.data
			},
			async toDeal() {
				if (this.yzList.check_id !== 0) {
					this.$message({
						message: '该项目已成交',
						type: 'warning'
					})
					return
				}
				if (this.result == '') {
					this.$message({
						message: '请选择成交乙方',
						type: 'warning'
					})
					return
				}
				const deal = await this.$api.chooseBpartyDeal({
					id: this.result,
					instrumenthelp_id: this.toolsDetail.id
				})
				if (deal.code == 1) {
					this.$message({
						message: deal.msg,
						type: 'success'
					})
					this.getToolsBindInfo()
				} else {
					this.$message({
						message: deal.msg,
						type: 'warning'
					})
				}
			},
			showDetail(item) {
				console.log(item);
				this.yzInfo = item
				this.dialogVisible1 = true

			},
			async getYzList() {
				const list = await this.$api.getToolsYZneedList({
					instrumenthelp_id: this.$route.query.id
				})
				this.yzList = list.data
				if (list.data.check_id != 0) {
					this.result = list.data.check_id
				}
				console.log(list);
			},
			async getToolDetail() {
				const detail = await this.$api.getToolsQzDetail({
					id: this.$route.query.id
				})
				this.toolsDetail = detail.data
				this.getToolsBindInfo()
			},
			async collectasd() {
				let col
				if (this.toolsDetail.collect == 0) {
					col = await this.$api.collectToolsQz({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 1
						this.toolsDetail.collect_num += 1
					}
				} else {
					col = await this.$api.cancelCollectToolsQz({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 0
						this.toolsDetail.collect_num -= 1
					}
				}
				this.$message({
					message: col.msg,
					type: 'success',
					center: true
				})
			},
			// reoserceToolShare
			async reoserceShare() {
				// 1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务
				const share = await this.$api.shareHandler({
					correlation_id: this.toolsDetail.id,
					type: 2
				})
				if (share.code == 1) {
					this.toolsDetail.share = 1
					this.toolsDetail.share_num += 1
				}
			},
			async LikeHandler() {
				let like
				if (this.toolsDetail.praise == 0) {
					like = await this.$api.getLikeToolsQz({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 1
						this.toolsDetail.praiset_num += 1
					}
				} else {
					like = await this.$api.cancelLikeToolsQz({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 0
						this.toolsDetail.praiset_num -= 1
					}
				}
				this.$message({
					message: like.msg,
					type: 'success',
					center: true
				})
			},
			// giveShitForTools
			// TakeBackShitFromTools
			async ShitHandler() {
				let shit
				if (this.toolsDetail.tread == 0) {
					shit = await this.$api.giveShitHandler({
						correlation_id: this.toolsDetail.id,
						type: 2
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 1
						this.toolsDetail.tread_num += 1
					}
				} else {
					shit = await this.$api.cancelGiveShitHandler({
						correlation_id: this.toolsDetail.id,
						type: 2
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 0
						this.toolsDetail.tread_num -= 1
					}
				}
				this.$message({
					message: shit.msg,
					type: 'success',
					center: true
				})
			},
		}
	}
</script>
<style>
	.el-date-editor.el-input {
		width: 100%;
	}

	input[type=checkbox] {
		cursor: pointer;
		position: relative;
		width: 25px;
		height: 24px;
		font-size: 16px;
	}

	input[type=checkbox]::after {
		position: absolute;
		top: 0;
		color: #000;
		width: 25px;
		height: 24px;
		display: inline-block;
		visibility: visible;
		padding-left: 0px;
		text-align: center;
		content: ' ';
		border-radius: 3px
	}

	input[type=checkbox]:checked::after {
		content: "✓";
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		background-color: #0052D9;
	}

	.el-rate {
		height: 30px;
	}

	.el-icon-star-on:before {
		font-size: 24px;
	}

	.el-icon-star-off:before {
		font-size: 24px;
	}

	.el-rate__icon {
		font-size: 24px;
	}

	/* .el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 18px;
		height: 18px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}

	.el-radio__inner {
		border-radius: 0;
	}
	
	.el-radio__label {
		display: none;
	}
	
	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */
</style>
<style lang="less" scoped>
	.pinglBtn {
		width: 132px;
		height: 38px;
		background: #0052D9;
		border: 1px solid #E5E5E5;
		margin-top: 20px;
		color: white;
		line-height: 38px;
		text-align: center;
		cursor: pointer;
	}

	.shareIconWrap {
		.shareIcon {
			display: none !important;
		}

		&:hover {
			.shareIcon {
				display: block !important;
			}
		}
	}

	.shareBox {
		.share {
			display: none !important;
		}

		&:hover {
			.share {
				display: block !important;
			}
		}
	}

	.body {
		display: flex;
		justify-content: space-between;

		.table {
			border: 1px solid #EEEEEE;
			text-align: center;

			.table-line {
				.jindu {
					width: 180px;
				}

				.line-status {
					width: 150px;
					border: 1px solid #EEEEEE;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.starScore {
					font-size: 30px;
					width: 190px;
					border: 1px solid #EEEEEE;
					display: flex;
					height: 100%;
					align-items: center;
					justify-content: center;
				}

				.zhuanjia {
					display: flex;
					flex: 1;
					justify-content: flex-end;

					div {
						margin-right: 20px;
						width: 132px;
						color: #0052D9;
						height: 34px;
						border: 1px solid #0052D9;
						line-height: 34px;
						cursor: pointer;
					}

					&>div:last-child {
						background: #0052D9;
						color: white;
					}
				}

				.line-icon {
					width: 75px;
					display: flex;
					justify-content: center;
					border: 1px solid #EEEEEE;
					height: 100%;
					align-items: center;

					img {
						width: 23px;
						height: 23px;
					}
				}

				.line-id {
					font-size: 18px;
					width: 75px;
				}

				.fangan {
					width: 210px;
				}

				.nickName {
					width: 200px;
				}

				.company {
					width: 250px;
				}

				.deal {
					width: 180px;
				}

				.score {
					width: 120px;
				}

				.status {
					width: 170px;
				}

				align-items: center;
				display: flex;
				font-size: 16px;
				border-bottom: 1px solid #EEEEEE;
				height: 55px;

				.line-check {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 50px;
					border: 1px solid #EEEEEE;
					height: 100%;
				}
			}

			.darkbg {
				background: #FAFAFA;
			}
		}

		.body-item-title {
			display: flex;
			justify-content: space-between;
			font-size: 18px;
			padding: 20px;
			align-items: center;

			&>div {
				cursor: pointer;
				line-height: 40px;
				text-align: center;
				padding: 0 10px;
				height: 40px;
				background: #F6F6F6;
				border: 1px solid #D2D2D2;
			}
		}

		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			height: 300px;
			background: #FFFFFF;
		}

		.body-mid-footer {
			display: flex;
			padding: 20px;
			box-sizing: border-box;
			height: 50px;
			background: #F6F6F6;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			align-items: center;
			margin: 10px auto;

			&>img {
				margin-left: 20px;
				width: 16px;
				height: 16px;
			}
		}

		.body-main {
			width: 900px;

			.main-body {


				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						width: 128px;
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						width: 128px;
						height: 40px;
						background: #0052D9;
						border-radius: 0px 20px 20px 0px;
					}
				}

				margin-top: 20px;
				padding: 20px;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 20px 5px;
						width: 280px;
					}

					.content-l {}
				}

				.bottom {
					display: flex;
					color: #888888;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 15px;
				}


				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
</style>